import { Link } from 'react-router';
import logo from '/images/logo-practivated.svg';
import { cn } from '@/lib/utils';

export const Header = ({ isOpenSimulation }: { isOpenSimulation: boolean }) => {
  return (
    <header
      data-testid="header"
      data-is-open={isOpenSimulation}
      className="bg-gradient-to-br from-indigo-100 to-purple-100 py-8 md:py-12 px-4"
    >
      <div
        className={cn('text-center flex flex-col items-center justify-center max-w-4xl mx-auto gap-6', {
          'md:flex-row md:justify-between md:text-left': isOpenSimulation
        })}
      >
        <Link to="/demo">
          <img src={logo} alt="Logo" className="w-[250px]" />
        </Link>
        <div className="space-y-1">
          <h1
            className={cn('text-2xl md:text-4xl font-bold text-[#2F2968]', {
              'text-2xl mb-0': isOpenSimulation
            })}
          >
            Step into a real conversation
          </h1>
          <p className="text-sm md:text-lg text-[#2F2968]">Try an interactive demo simulation — no signup needed</p>
        </div>
      </div>
    </header>
  );
};
